<template>
  <div>
    <vue-multiselect
      v-model="model"
      :options="options"
      label="name"
      track-by="staff_id"
      :multiple="limit > 1"
      placeholder="Search by name"
      :value="null"
      :loading="loading"
      :disabled="disable || loading"
    />
    <input
      type="hidden"
      :name="inputName"
      :value="modelToValue"
    >
  </div>
</template>
<script>
import VueMultiselect from 'vue-multiselect'

export default {
    name: 'AdminStaffAssigned',
    components: { VueMultiselect },
    props: {
        projectId: {
            type: [Number, String],
            required: false,
            default () {
                return null
            },
        },
        limit: {
            type: [Number, String],
            required: false,
            default () {
                return 100
            },
        },
        inputName: {
            type: String,
            required: false,
            default () {
                return 'staff'
            },
        },
        staffAssigned: {
            type: [Array],
            required: false,
            default () {
                return []
            },
        },
        staffAssignedId: {
            type: [Number, String],
            required: false,
            default () {
                return null
            },
        },
        staff: {
            type: [Array],
            required: true,
        },
        parentStaff: {
            type: [Object, Array],
            required: false,
            default: () => null,
        },
        self: {
            type: [Object],
            required: false,
            default: () => null,
        },
        admin: {
            type: Boolean,
            required: false,
            default () {
                return false
            },
        },
        newProject: {
            type: Boolean,
            required: false,
            default () {
                return true
            },
        },
    },
    data () {
        return {
            model: [],
            loading: false,
        }
    },
    computed: {
        modelToValue () {
            if (Array.isArray(this.model)) {
                const arr = []
                this.model.forEach(v => {
                    arr.push(v.staff_id)
                })
                return arr
            } else {
                return this.model ? this.model.staff_id : ''
            }
        },
        disable () {
            return !this.admin
        },
        options () {
            const ret = []
            let result = []

            this.staff.forEach((v, i) => {
                const obj = {
                    staff_id: v.id,
                    name: `${v.user.first_name} ${v.user.last_name}`,
                    roles: v.user.roles,
                }
                ret.push(obj)
            })

            if (this.isConsultant) {
                result = ret.filter(function (v, idx) {
                    return v.roles.every(role => role.name === 'Leads Specialist')
                })
            } else {
                result = ret
            }

            return result
        },
        modelComputed () {
            return this.model || []
        },
        isStaff () {
            return this.self.roles[0].name !== 'Super Admin'
        },
        isConsultant () {
            return this.self.roles[0].name === 'Consultant'
        }
    },
    watch: {
        modelComputed () {
            this.$store.commit('project/setSelectedProjectStaff', this.model)
        },
    },
    mounted () {
        if (this.staffAssignedId) {
            const myID = this.staffAssignedId
            const ret = this.staff.filter(v => Number(v.id) === Number(myID))
            if (ret) {
                const obj = {
                    staff_id: ret[0].id,
                    user_id: ret[0].user.id,
                    name: `${ret[0].user.first_name} ${ret[0].user.last_name}`,
                }
                this.model.push(obj)
            }
        } else if (this.self) {
            const myID = this.self.id
            const parentStaff = this.parentStaff

            if (this.newProject) { //include parent staff and higher role staffs when create project
                const ret = this.staff.filter(v =>
                    Number(v.user.id) === Number(myID)
                    // || Number(v.user.id) === Number(parentStaffId)
                        || v.user.roles.every(role => role.name === 'Super Admin')
                    || Object.values(parentStaff).includes(v.user.id)
                )

                if (ret.length) {
                    this.model = ret.map(staff => ({
                        staff_id: staff.id,
                        user_id: staff.user.id,
                        name: `${staff.user.first_name} ${staff.user.last_name}`,
                        $isDisabled: this.isConsultant &&
                            staff.user.roles.every(role => role.name !== 'Leads Specialist'),
                    }))
                }
            } else if (this.staffAssigned.length) { //add all assigned staff to select options
                this.staffAssigned.forEach(v => {
                    const obj = {
                        staff_id: v.id,
                        user_id: v.user.id,
                        name: `${v.user.first_name} ${v.user.last_name}`,
                        $isDisabled: this.isConsultant && v.user.roles.every(role => role.name !== 'Leads Specialist'),
                    }
                    this.model.push(obj)
                })
            } /*else {
        const ret = this.staff.filter(function(staff) {
            return Number(staff.user.id) === Number(myID)
        })

        const obj = {
          staff_id: ret[0].id,
          user_id: ret[0].user.id,
          name: `${ret[0].user.first_name} ${ret[0].user.last_name}`,
        };

        this.model.push(obj);
      }*/
        }
        // this.$store.commit('project/setSelectedProjectStaff', selectedStaff)
    },
}
</script>
